<div class="wrapper">
  <div class="left">
    <form [formGroup]="form" novalidate>
      <div style="border-bottom: 1px solid lightgrey;">
        <img src="../../../assets/oddfellow_logga.PNG">
      </div>
      <div class="row margin-top">
        <div class="col-xs-2">
          <input placeholder="Användarnamn" formControlName="username" class="form-control field" required>
        </div>
        <div class="col-xs-2">
          <input type="password" placeholder="Lösenord" formControlName="password" class="form-control field" required>
        </div>
        <div class="col-xs-5">
          <button (click)="onSubmit()" class="btn btn-outline-primary" style="margin-left:20px;">Logga in</button>
        </div>
      </div>
    </form>
  </div>
  <div class="right">
    <img src="../../../assets/stavar_login_vertical.png">
  </div>
</div>